import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  constructor(private http: HttpClient) {}

  public getNewToken(tokenId: string, captchaToken: string): Observable<any> {
    const url = `${environment.appUrl}/auth/token/google?token_id=${tokenId}&captcha_token=${captchaToken}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        this.saveTokens(resp);
      })
    );
  }

  public getNewTokenNoauth(userId: string): Observable<any> {
    const url = `${environment.appUrl}/auth/token/noauth?user=${userId}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        this.saveTokens(resp);
      })
    );
  }

  public getNewTokenLdap(userId: string, password: string, captchaToken: string): Observable<any> {
    const url = `${environment.appUrl}/auth/token/ldap`;
    const body = {
      userName: userId,
      encodedPassword: btoa(password),
      captchaToken
    };

    return this.http.post(url, body).pipe(
      map((resp: any) => {
        this.saveTokens(resp);
      })
    );
  }

  public refreshToken(): Observable<any> {
    const url = `${environment.appUrl}/auth/token`;
    return this.http
      .post(url, {
        refreshToken: this.getRefreshToken()
      })
      .pipe(
        tap((resp) => {
          this.saveTokens(resp);
        })
      );
  }

  public getAccessToken(): string {
    return this.getCookie('accessToken');
  }

  private getRefreshToken(): string {
    return this.getCookie('refreshToken');
  }

  private saveTokens(resp: any) {
    this.setCookie('refreshToken', resp.refreshToken);
    this.setCookie('accessToken', resp.accessToken);
  }

  private deleteTokens() {
    this.deleteCookie('refreshToken');
    this.deleteCookie('accessToken');
  }

  private setCookie(name, value) {
    document.cookie = `${name}=${value}; path=/; domain=.griddynamics.net`;
  }

  private deleteCookie(name) {
    document.cookie = `${name}=; path=/; domain=.griddynamics.net; expires=Thu, 01-Jan-70 00:00:01 GMT;`;
  }

  private getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  }
}
